import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "./api";
import { useAuth } from "../context/AuthContext";

const KEY = "phw_vid";

export function visitorId(): string {
  let v = localStorage.getItem(KEY);
  if (!v) {
    v = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`).replace(/-/g, "").slice(0, 32);
    localStorage.setItem(KEY, v);
  }
  return v;
}

export function PageTracker() {
  const { pathname, search } = useLocation();
  const { user } = useAuth();
  const last = useRef<string>("");
  useEffect(() => {
    if (user === null) return;
    const path = pathname + search;
    if (path === last.current || pathname.startsWith("/admin")) return;
    last.current = path;
    api.post("/activity/page", { path, visitor_id: visitorId(), referrer: document.referrer || "", title: document.title || "" }).catch(() => undefined);
  }, [pathname, search, user]);
  return null;
}
